import { call, put, select, take } from 'redux-saga/effects';
import { serviceUnavailable } from '../../../modules/app/actions';
import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';
import { restartUserJourney } from '../../../modules/auth/saga';
import { close, open } from '../../../modules/modal/actions';
import * as form from '../../FormMessage/actions';
import * as notify from '../../layout/Notifications/actions';
import { getMobileNumber } from '../../../modules/account/selectors';
import {
  CHANGE_PHONE_NUMBER_CONFIRM,
  CHANGE_PHONE_NUMBER_REJECT,
  CHANGE_PHONE_NUMBER_REQUEST,
  changePhoneNumberFailure,
  changePhoneNumberSuccess
} from './actions';
import { NumberExistError, WrongNumberError } from './errors';
import { postChangeNumber } from './rest';

/* eslint-disable no-constant-condition */
export default function* watchChangePhoneNumberRequest() {
  while (true) {
    const { mobileNumber } = yield take(CHANGE_PHONE_NUMBER_REQUEST);
    const oldNumber = yield select(getMobileNumber);
    try {
      yield put(form.clearMessage());
      // prompt for confirm
      yield put(open({ componentName: 'MobileNumberConfirmation' }));
      const { type } = yield take([CHANGE_PHONE_NUMBER_CONFIRM, CHANGE_PHONE_NUMBER_REJECT]);
      yield put(close());

      if (type === CHANGE_PHONE_NUMBER_CONFIRM) {
        yield put(open({ componentName: 'RequestInProgress' }));
        yield call(postChangeNumber, oldNumber, mobileNumber);
        yield put(changePhoneNumberSuccess());
        yield put(open({ componentName: 'MobileNumberChanged' }));
      }
    } catch (e) {
      yield put(changePhoneNumberFailure(e));
      yield put(close());
      if (e instanceof WrongNumberError) {
        yield put(form.setMessage(
          form.ERROR,
          'WrongNumber',
          { mobileNumber: ' ' },
          false
        ));
      } else if (e instanceof NumberExistError) {
        yield put(form.setMessage(
          form.ERROR,
          'There was a problem changing your mobile number. Please check the highlighted field.',
          { mobileNumber: 'This number is currently registered to another account' }
        ));
      } else if (e instanceof UnauthorizedAccessError) {
        yield call(restartUserJourney);
      } else if (e instanceof ConnectionError) {
        yield put(notify.add('Connection error.', notify.ERROR));
      } else if (e instanceof ServiceUnavailableError) {
        yield put(serviceUnavailable());
      } else {
        throw e;
      }
    }
  }
}
/* eslint-enable no-constant-condition */
